import React from 'react';
import ReactDom from 'react-dom';

import { useRunsViewMode } from '@neptune/project-runs-business-logic';

import { CompareProjectHeaderContainer } from './CompareProjectHeaderContainer';
import { DetailsProjectHeaderContainer } from './DetailsProjectHeaderContainer';

type ProjectHeaderContentContainerProps = {
  target: HTMLElement | null;
  tabs: React.ReactNode;
  additionalElementRef?: React.ForwardedRef<HTMLElement>;
  lbViewPicker?: React.ReactNode;
  colorListPicker?: React.ReactNode;
};

export const ProjectHeaderContainer: React.FC<ProjectHeaderContentContainerProps> = ({
  target,
  tabs,
  lbViewPicker,
  colorListPicker,
  additionalElementRef,
}) => {
  const { dashboardMode } = useRunsViewMode();

  if (!target) {
    return null;
  }

  const children =
    dashboardMode === 'single' ? (
      <DetailsProjectHeaderContainer tabs={tabs} additionalElementRef={additionalElementRef} />
    ) : (
      <CompareProjectHeaderContainer
        tabs={tabs}
        additionalElementRef={additionalElementRef}
        lbViewPicker={lbViewPicker}
        colorListPicker={colorListPicker}
      />
    );

  return ReactDom.createPortal(children, target);
};
